import styled from 'styled-components';
import { useLangContext } from '../../../providers/LangProvider/LangProviderContext';
import LandingArrow from './LandingArrow';

const LandingPremiumStyled = styled.section``;

function LandingPremium({ onOpenContact }) {
    const { getLangPath } = useLangContext();

    return (
        <LandingPremiumStyled className="block top" id="premium">
            <div className="wrap">
                <div className="section-head">
                    <div>
                        <div className="kicker">{getLangPath('landing.premium.kicker')}</div>
                        <h2>
                            {getLangPath('landing.premium.titleLine1')}
                            <br/>
                            {getLangPath('landing.premium.titleLine2')}
                        </h2>
                    </div>
                </div>
                <div className="top-grid">
                    <article className="white-label">
                        <div>
                            <span className="badge">{getLangPath('landing.premium.badge')}</span>
                            <h3>
                                {getLangPath('landing.premium.telegramLine1')}
                                <br/>
                                {getLangPath('landing.premium.telegramLine2')}
                            </h3>
                            <p>{getLangPath('landing.premium.whiteLabelText')}</p>
                        </div>
                        <div className="phone" aria-hidden="true">
                            <div className="phone-brand">{getLangPath('landing.premium.brand')}</div>
                            <div className="signal">
                                {getLangPath('landing.premium.community')}
                                <strong>{getLangPath('landing.premium.signals')}</strong>
                                <div className="spark">
                                    <i/><i/><i/><i/><i/>
                                </div>
                            </div>
                            <div className="signal">
                                {getLangPath('landing.premium.experience')}
                                {' '}
                                <LandingArrow/>
                            </div>
                        </div>
                    </article>
                    <div>
                        <article className="service">
                            <h3>{getLangPath('landing.premium.marketingTitle')}</h3>
                            <p>{getLangPath('landing.premium.marketingText')}</p>
                        </article>
                        <article className="service">
                            <h3>{getLangPath('landing.premium.termsTitle')}</h3>
                            <p>{getLangPath('landing.premium.termsText')}</p>
                        </article>
                        <article className="service">
                            <h3>{getLangPath('landing.premium.roadmapTitle')}</h3>
                            <p>{getLangPath('landing.premium.roadmapText')}</p>
                        </article>
                    </div>
                </div>
                <div className="closing">
                    <div>
                        <h3>{getLangPath('landing.premium.closingTitle')}</h3>
                        <p>{getLangPath('landing.premium.closingText')}</p>
                    </div>
                    <button className="btn" type="button" aria-haspopup="dialog" aria-controls="contact" onClick={onOpenContact}>
                        {getLangPath('landing.premium.cta')}
                        {' '}
                        <LandingArrow/>
                    </button>
                </div>
            </div>
        </LandingPremiumStyled>
    );
}

export default LandingPremium;
